window.addEventListener('load', () => {
  gsap.registerPlugin(ScrollTrigger);

  const sequences = document.querySelectorAll('.message-testimonial-sequence');

  // Hide all elements initially
  sequences.forEach(seq => {
    gsap.set(seq.querySelector('.typing-indicator'), { autoAlpha: 0 });
    gsap.set(seq.querySelector('.message-testimonial'), { autoAlpha: 0, height: 0 });
    gsap.set(seq.querySelector('.message-testimonial__reaction'), { autoAlpha: 0, scale: 0.5 });
  });

  // One master timeline for all sequences
  const masterTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: '.message-testimonials',
      start: 'top 80%',
      once: true,
      // markers: true // remove when not debugging
    }
  });

  sequences.forEach(sequence => {
    const typing = sequence.querySelector('.typing-indicator');
    const message = sequence.querySelector('.message-testimonial');
    const reaction = sequence.querySelector('.message-testimonial__reaction');

    masterTimeline
      .to(typing, { autoAlpha: 1, duration: 0.3 })
      .to(typing, { duration: 1.2 }) // pause to simulate typing
      .to(typing, {
        autoAlpha: 0,
        height: 0,
        marginBottom: 0,
        paddingTop: 0,
        paddingBottom: 0,
        duration: 0.3,
        ease: "power1.inOut"
      })
      .to(message, {
        autoAlpha: 1,
        height: "auto",
        duration: 0.6,
        ease: "power1.out"
      })
      .to(reaction, {
        autoAlpha: 1,
        scale: 1,
        duration: 0.1,
        ease: "back.out(1.7)"
      }, "+=0.5");
  });
});
